declare var _gaq: any;

export class SimpleTabs {
    constructor() {
        const tabModules: NodeListOf<HTMLElement> = document.querySelectorAll("[data-simple-tabs]") as NodeListOf<HTMLElement>;
        if (tabModules && tabModules.length > 0) {
            for (let i = 0; i < tabModules.length; i++) {
                this.HideAllTabs(i);
                this.BindTabTriggerActions(i);
                this.ActivateFirstTab(i);
            }           
        }
    }

    private HideAllTabs(n: number): void {
        const tabs: NodeListOf<HTMLElement> = document.querySelectorAll(`[data-simple-tabs="${n}"] [data-simple-tab]`) as NodeListOf<HTMLElement>;
        for (let i = 0; i < tabs.length; i++) {
            tabs[i].style.display = "none";
        }
    }

    private BindTabTriggerActions(n: number): void {
        const triggers: NodeListOf<HTMLElement> = document.querySelectorAll(`[data-simple-tab-menu="${n}"] [data-simple-tab-trigger]`) as NodeListOf<HTMLElement>;
        const tabs: NodeListOf<HTMLElement> = document.querySelectorAll(`[data-simple-tabs="${n}"] [data-simple-tab]`) as NodeListOf<HTMLElement>;

        for (let i = 0; i < triggers.length; i++) {
            triggers[i].addEventListener("click", () => {
                const id = parseInt(triggers[i].getAttribute("data-simple-tab-trigger"), 10);

                for (let j = 0; j < tabs.length; j++) {
                    const tabid: number = parseInt(tabs[j].getAttribute("data-simple-tab"), 10);

                    if (tabid === id) {
                        tabs[j].style.display = "block";
                        setTimeout(() => { tabs[j].classList.add("opacity1"); }, 1);
                        triggers[j].classList.add("active");
                    } else {
                        tabs[j].style.display = "none";
                        tabs[j].classList.remove("opacity1");
                        triggers[j].classList.remove("active");
                    }                  
                }
            });
        }
    }

    private ActivateFirstTab(n: number): void {
        const triggers: NodeListOf<HTMLElement> = document.querySelectorAll(`[data-simple-tab-menu="${n}"] [data-simple-tab-trigger]`) as NodeListOf<HTMLElement>;
        triggers[0].click();
    }

}



// WEBPACK FOOTER //
// ./src/global/SimpleTabs.ts